interface LogEntry {
  timestamp: string
  level: 'INFO' | 'WARN' | 'ERROR' | 'DEBUG'
  category: string
  message: string
  data?: any
  userAgent?: string
  url?: string
}

class Logger {
  private logs: LogEntry[] = []
  private maxLogs = 1000 // Максимум логов в памяти

  private createLogEntry(level: LogEntry['level'], category: string, message: string, data?: any): LogEntry {
    return {
      timestamp: new Date().toISOString(),
      level,
      category,
      message,
      data,
      userAgent: navigator.userAgent,
      url: window.location.href
    }
  }

  private addLog(entry: LogEntry) {
    this.logs.push(entry)
    
    // Ограничиваем количество логов в памяти
    if (this.logs.length > this.maxLogs) {
      this.logs = this.logs.slice(-this.maxLogs)
    }

    // Выводим в консоль для отладки
    const consoleMethod = entry.level === 'ERROR' ? 'error' : 
                         entry.level === 'WARN' ? 'warn' : 
                         entry.level === 'DEBUG' ? 'debug' : 'log'
    
    console[consoleMethod](`[${entry.timestamp}] [${entry.level}] [${entry.category}] ${entry.message}`, entry.data || '')
  }

  info(category: string, message: string, data?: any) {
    this.addLog(this.createLogEntry('INFO', category, message, data))
  }

  warn(category: string, message: string, data?: any) {
    this.addLog(this.createLogEntry('WARN', category, message, data))
  }

  error(category: string, message: string, data?: any) {
    this.addLog(this.createLogEntry('ERROR', category, message, data))
  }

  debug(category: string, message: string, data?: any) {
    this.addLog(this.createLogEntry('DEBUG', category, message, data))
  }

  // Получить все логи
  getLogs(): LogEntry[] {
    return [...this.logs]
  }

  // Очистить логи
  clearLogs() {
    this.logs = []
  }

  // Экспорт логов в JSON
  exportLogs(): string {
    return JSON.stringify(this.logs, null, 2)
  }

  // Скачать логи как файл
  downloadLogs() {
    const logsJson = this.exportLogs()
    const blob = new Blob([logsJson], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `frontend-logs-${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.json`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  // Отправить логи на сервер (если нужно)
  async sendLogsToServer() {
    try {
      const logsJson = this.exportLogs()
      await fetch('/api/logs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: logsJson
      })
      this.info('LOGGER', 'Логи отправлены на сервер')
    } catch (error) {
      this.error('LOGGER', 'Ошибка отправки логов на сервер', error)
    }
  }
}

// Создаем глобальный экземпляр логгера
export const logger = new Logger()

// Добавляем в window для доступа из консоли браузера
if (typeof window !== 'undefined') {
  (window as any).logger = logger
}

// Логируем загрузку страницы
logger.info('APP', 'Приложение загружено', {
  url: window.location.href,
  userAgent: navigator.userAgent,
  timestamp: new Date().toISOString()
})
